import triggerTracking from '@blueprint/tracking';
import { TRACKING_EVENT, TRACKING_CATEGORY } from 'listing-details/constants';

export const trackNextFloorPlan = (slideIndex: number) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'click',
        eventLabel: 'next floorplan',
        eventValue: slideIndex + 1
    });
};

export const trackPreviousFloorPlan = (slideIndex: number) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'click',
        eventLabel: 'previous floorplan',
        eventValue: slideIndex + 1
    });
};

export const trackZoomFloorPlan = (slideIndex: number) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'zoom',
        eventLabel: 'floorplan gallery',
        eventValue: slideIndex + 1
    });
};

export const trackFloorPlanExternalItemClick = (
    itemIndex: number,
    type: 'pdf' | 'link'
) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'clickthrough',
        eventLabel: `floorplan ${type}`,
        eventValue: itemIndex + 1
    });
};
